import React, { useState } from "react";
import { Typography, Box, Grid, Button } from "@mui/material";
import { Edit } from "@mui/icons-material";
import QuestionnaireSummaryCard from "./QuestionnaireSummaryCard";
import { SuccessSnackbar } from "./Snackbar/SuccessSnackbar";
import { ErrorSnackbar } from "./Snackbar/ErrorSnackbar";
import { BANNER_COLOR_LIGHT, TEXT_COLOR } from "../pages/root";

const InstrumentSection = ({ instrument, onEdit, onAddQuestionnaires }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filteredQuestionnaires, setFilteredQuestionnaires] = useState(instrument.questionnaires || []);
  const [action, setAction] = useState("");

  const handleQuestionnaireDeleted = (questionnaireId, action = "deleted") => {
    setFilteredQuestionnaires((prevQuestionnaires) => prevQuestionnaires.filter((q) => q.id !== questionnaireId));
    setAction(action);
    setShowSuccess(true);
  };

  const handleQuestionnaireError = (message) => {
    setErrorMessage(message);
    setShowError(true);
  };

  return (
    <>
      <Box
        sx={{
          mb: 3,
          p: 3,
          bgcolor: "background.paper",
          borderRadius: 2,
          borderLeft: "4px solid",
          borderColor: BANNER_COLOR_LIGHT,
          boxShadow: 1,
          transition: "all 0.3s ease",
          "&:hover": { boxShadow: 3 },
        }}
      >
        {/* Encabezado del instrumento */}
        <Box
          sx={{
            mb: 2,
            pb: 2,
            borderBottom: "1px solid",
            borderColor: TEXT_COLOR,
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="body2">
                <Box component="span" fontWeight={600}>
                  Instrumento ID:
                </Box>{" "}
                {instrument.id}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex", gap: 1, justifyContent: { xs: "flex-start", md: "flex-end" } }}>
              <Button variant="contained" size="small" onClick={() => onEdit(instrument)} sx={{ textTransform: "none" }}>
                Editar
              </Button>
              <Button variant="contained" size="small" onClick={() => onAddQuestionnaires(instrument)} sx={{ textTransform: "none" }}>
                Agregar cuestionarios
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <Box component="span" fontWeight={600}>
                  Nombre:
                </Box>{" "}
                {instrument.name}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Cuestionarios relacionados */}
        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle2" fontWeight={300} mb={2}>
            Cuestionarios asociados a este instrumento:
          </Typography>

          {filteredQuestionnaires?.length > 0 ? (
            <Grid container spacing={2}>
              {filteredQuestionnaires.map((questionnaireItem) => (
                <Grid item xs={12} sm={6} md={4} key={questionnaireItem.id}>
                  <QuestionnaireSummaryCard
                    questionnaireItem={questionnaireItem}
                    onDelete={handleQuestionnaireDeleted}
                    onError={handleQuestionnaireError}
                    parent={{ type: "instrument", id: instrument.id }}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body2" color="text.secondary" fontStyle="italic">
              No hay cuestionarios asociados a este instrumento.
            </Typography>
          )}
        </Box>
      </Box>

      <SuccessSnackbar
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={`Cuestionario ${action == "unlink" ? "desvinculado" : "eliminado"} satisfactoriamente`}
      />
      <ErrorSnackbar open={showError} onClose={() => setShowError(false)} message={errorMessage} />
    </>
  );
};

export default InstrumentSection;
